<template>
  <div id="app">
    <router-view id="page" class="page" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    layout() {
      return this.$route.meta.layout || "default-layout";
    },
    user() {
      return this.$store.state.auth.user;
    },
    account_id() {
      return this.$store.state.auth.user.account;
    },
  },
  mounted() {
    window.appflowzConfig = {
      account: "361bfc06-71c2-4fc9-bdd9-bfe4c6fda967", //your account id
      email: `"${this.user.email}"`, //user's email address
      user_id: `"${this.account_id}"`, //user's id (optional)
      name: `"${this.user.name}"`, //user's name (optional)
      container: document.body,
    };

    var script = document.createElement("script");
    var tag = document.getElementsByTagName("script")[0];
    script.src = "https://script.appflowz.com/loader.min.js";
    tag.parentNode.insertBefore(script, tag);
  },
};
</script>

<style lang="scss">
@import "./assets/global.scss";
.page {
  min-height: calc(100vh - 56px);
}
</style>
